import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  ESIGN_LIST,
  ESIGN_DATA,
  ESIGN_CREATE,
  ESIGN_UPDATE,
  ESIGN_DOCUMENT_UPLOAD,
  ESIGN_SEND,
  ESIGN_VOID,
  ESIGN_DOWNLOAD,
  ESIGN_DELETE,
} from "./actionType";

import {
  listESignSuccess,
  listESignFailure,
  getESignDataSuccess,
  getESignDataFailure,
  createESignSuccess,
  createESignFailure,
  updateESignSuccess,
  updateESignFailure,
  uploadESignDocumentSuccess,
  uploadESignDocumentFailure,
  sendESignSuccess,
  sendESignFailure,
  voidESignSuccess,
  voidESignFailure,
  downloadESignSuccess,
  downloadESignFailure,
  deleteESignSuccess,
  deleteESignFailure,
} from "./action";

import {
  listESignApi,
  getESignDataApi,
  createESignApi,
  updateESignApi,
  uploadESignDocumentApi,
  sendESignApi,
  voidESignApi,
  downloadESignApi,
  deleteESignApi,
} from "../../helpers/fakebackend_helper";

// List envelopes
function* listESign() {
  try {
    const response = yield call(listESignApi);
    yield put(listESignSuccess(response));
  } catch (error) {
    yield put(listESignFailure(error));
  }
}

function* listESignWatcher() {
  yield takeEvery(ESIGN_LIST, listESign);
}

// Read one envelope (full nested bundle)
function* getESignData({ payload }) {
  try {
    const response = yield call(getESignDataApi, payload);
    yield put(getESignDataSuccess(response));
  } catch (error) {
    yield put(getESignDataFailure(error));
  }
}

function* getESignDataWatcher() {
  yield takeEvery(ESIGN_DATA, getESignData);
}

// Create draft
function* createESign({ payload }) {
  try {
    const response = yield call(createESignApi, payload);
    yield put(createESignSuccess(response));
  } catch (error) {
    yield put(createESignFailure(error));
  }
}

function* createESignWatcher() {
  yield takeEvery(ESIGN_CREATE, createESign);
}

// Update draft
function* updateESign({ payload }) {
  try {
    const response = yield call(updateESignApi, payload);
    yield put(updateESignSuccess(response));
  } catch (error) {
    yield put(updateESignFailure(error));
  }
}

function* updateESignWatcher() {
  yield takeEvery(ESIGN_UPDATE, updateESign);
}

// Upload document (base64 PDF)
function* uploadESignDocument({ payload }) {
  try {
    const response = yield call(uploadESignDocumentApi, payload);
    yield put(uploadESignDocumentSuccess(response));
  } catch (error) {
    yield put(uploadESignDocumentFailure(error));
  }
}

function* uploadESignDocumentWatcher() {
  yield takeEvery(ESIGN_DOCUMENT_UPLOAD, uploadESignDocument);
}

// Send (issue links + emails)
function* sendESign({ payload }) {
  try {
    const response = yield call(sendESignApi, payload);
    yield put(sendESignSuccess(response));
  } catch (error) {
    yield put(sendESignFailure(error));
  }
}

function* sendESignWatcher() {
  yield takeEvery(ESIGN_SEND, sendESign);
}

// Void
function* voidESign({ payload }) {
  try {
    const response = yield call(voidESignApi, payload);
    yield put(voidESignSuccess(response));
  } catch (error) {
    yield put(voidESignFailure(error));
  }
}

function* voidESignWatcher() {
  yield takeEvery(ESIGN_VOID, voidESign);
}

// Download completed signed PDF
function* downloadESign({ payload }) {
  try {
    const response = yield call(downloadESignApi, payload);
    yield put(downloadESignSuccess(response));
  } catch (error) {
    yield put(downloadESignFailure(error));
  }
}

function* downloadESignWatcher() {
  yield takeEvery(ESIGN_DOWNLOAD, downloadESign);
}

// Delete
function* deleteESign({ payload }) {
  try {
    const response = yield call(deleteESignApi, payload);
    yield put(deleteESignSuccess(response));
  } catch (error) {
    yield put(deleteESignFailure(error));
  }
}

function* deleteESignWatcher() {
  yield takeEvery(ESIGN_DELETE, deleteESign);
}

export default function* ESign() {
  yield all([
    fork(listESignWatcher),
    fork(getESignDataWatcher),
    fork(createESignWatcher),
    fork(updateESignWatcher),
    fork(uploadESignDocumentWatcher),
    fork(sendESignWatcher),
    fork(voidESignWatcher),
    fork(downloadESignWatcher),
    fork(deleteESignWatcher),
  ]);
}
